module.exports = __webpack_public_path__ + "static/media/firehazard.218bcee4.png";